import Vue from 'vue'
import Router from 'vue-router'
import portalSeguranca from './seguranca/index'
import cadastro from './cadastro/index'
import vistoria from './vistoria/index'
import dashboard from './dashboard/index'
import salaMonitoramento from './sala-monitoramento/index'
import certificacao from './certificacao/index'
import store from '@/store'
import PERFIL from '@/constants/perfil'

// DADOS PARAMETRIZADOS POR ESTADO
const MENU = require('@/constants/' + process.env.ESTADO + '/menu').MENUS

Vue.use(Router)

const router = new Router({
  routes: [
    ...portalSeguranca,
    ...cadastro,
    ...vistoria,
    ...dashboard,
    ...salaMonitoramento,
    ...certificacao
  ]
})

const redirecionarUsuario = (usuario, perfis, next, name) => {
  const usuarioTemPermissao = perfis ? perfis.indexOf(usuario.perfilSelecionado.codigo) !== -1 : true

  if (usuarioTemPermissao) {
    next()
  } else {
    next('/' + usuario.perfilSelecionado.paginaInicial ? usuario.perfilSelecionado.paginaInicial : 'selecionarModulo')
  }

  return usuarioTemPermissao
}

const selecionarMenuUsuario = async (usuario, next, to) => {
  const MODULO = await PERFIL[usuario.moduloSelecionado.codigo]
  if (!MODULO) {
    return
  }

  if (usuario.perfilSelecionado.modulo === 'DIAGNOSTICO') {
    let menu = await MENU[MODULO[usuario.perfilSelecionado.modulo].codigo]

    if (to.meta && to.meta.isSubmenu) {
      menu = menu.filter(item => item.routeGroup === to.meta.parentRouteGroup)[0].subMenu
    }
    store.dispatch('menu/setMenu', menu)
    return
  }

  if (!MODULO[usuario.perfilSelecionado.codigo]) {
    return
  }

  let menu = await MENU[MODULO[usuario.perfilSelecionado.codigo].codigo]

  if (to.meta && to.meta.isSubmenu) {
    menu = menu.filter(item => item.routeGroup === to.meta.parentRouteGroup)[0].subMenu
  }

  store.dispatch('menu/setMenu', menu)
}

const verificarModuloUsuario = async (to, from, next) => {
  let usuario = await store.dispatch('auth/getUsuario')

  if (usuario) {
    store.commit('auth/SET_USUARIO', usuario)
    if (usuario.perfilSelecionado) {
      await store.dispatch('auth/setPermissoes')
    }

    if (usuario.perfilSelecionado) {
      selecionarMenuUsuario(usuario, next, to)
      redirecionarUsuario(usuario, to.meta.perfis, next, to.name)
    } else {
      next()
    }
  } else {
    next('/login')
  }
}

const isAuthenticated = async (to, from, next) => {
  if (to.meta.isPublic) {
    next()
    return
  }

  verificarModuloUsuario(to, from, next)
}

router.beforeEach(async (to, from, next) => {
  const token = new URL(location.href).searchParams.get('token')
  if (token) {
    store.dispatch('auth/setToken', token)
    window.location.href = process.env.ROOT_URL + '#/selecionarModulo'
    return
  }
  isAuthenticated(to, from, next)
  Vue.nextTick(() => {
    const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)
    if (nearestWithTitle) {
      document.title = nearestWithTitle.meta.title
    }
    if (from.name) {
      if (!to.meta.previousRoute) {
        to.meta.previousRoute = {
          name: from.name,
          path: from.path,
          params: from.params,
          query: from.query,
          meta: {...from.meta, previousRoute: null}
        }
      }
    }
  })
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js